import { render, staticRenderFns } from "./AffiliateOverall.vue?vue&type=template&id=00ef2c22&scoped=true"
import script from "./AffiliateOverall.vue?vue&type=script&lang=js"
export * from "./AffiliateOverall.vue?vue&type=script&lang=js"
import style0 from "./AffiliateOverall.vue?vue&type=style&index=0&id=00ef2c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef2c22",
  null
  
)

export default component.exports